module.exports = __webpack_public_path__ + "img/logo.eec6cb8e.png";